import React, { useCallback } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { createUseStyles } from "react-jss";
import { Formik, Form } from "formik";
import { SelectField } from "../../forms/inputGroup/helpers";
import { useDispatch, useSelector } from "react-redux";
import { getAvailDestsByThemeSelector } from "../../../selectors/metadata/destinations";
import { tourSearchFormChange } from "../../../actions/search";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import jssVariables from "../../../jss_setup";

const styles = createUseStyles({
  miSearchForm: (props) => ({
    display: "grid",
    gridTemplateRows: "repeat(2, max-content)",
    gridGap: `calc(${jssVariables.normal_gap} / 2)`,
    ..._.get(props, "customStyles.miSearchForm", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    miSearchForm: (props) => ({
      gridTemplateRows: "unset",
      gridTemplateColumns: "20rem 1fr",
      gridGap: `calc(${jssVariables.normal_gap} / 2)`,
      alignItems: "end",
      padding: jssVariables.normal_gap,
      ..._.get(props, "customStyles.miSearchForm..smallscreen", {}),
    }),
  },
});
export const MiSearchForm = ({
  destinationPlaceholder,
  search_form,
  onFormUpdate,
  customStyles,
  ghost,
  autocomplete,
  categories,
  valueCategories,
  theme,
  onFormSearch,
  setLoadingSearchBtn,
  children,
}) => {
  const history = useHistory();
  const classes = styles({ customStyles });

  const destinations = useSelector((state) =>
    getAvailDestsByThemeSelector(state, { theme })
  );

  const destOptions = _.sortBy(
    destinations.map((dest) => [dest.id, dest.name_en]),
    (v) => v[1]
  );

  const dispatch = useDispatch();
  const updateTourSearchForm = useCallback(
    async ({ destination_codes }) =>
      await dispatch(
        tourSearchFormChange("destination_code", destination_codes)
      ),
    [dispatch]
  );

  return destinations.length === 0 ? null : (
    <Formik
      initialValues={{
        destination: _.get(destOptions, "0.0"),
      }}
      validate={(values) => {
        const errors = {};
        if (!values.destination) {
          const msg = "Please select a destination first";
          toast.error(msg, { duration: 5000 });
          errors["destination"] = msg;
        }
        return errors;
      }}
      onSubmit={async (values) => {
        await updateTourSearchForm({ destination_codes: [values.destination] });
        history.push(`/${theme}/`);
      }}>
      <Form className={classes.miSearchForm}>
        <SelectField
          name="destination"
          label="Destination"
          options={destOptions}
        />
        {children}
      </Form>
    </Formik>
  );
};
MiSearchForm.propTypes = {
  theme: PropTypes.string.isRequired,
  customStyles: PropTypes.object.isRequired,
  setLoadingSearchBtn: PropTypes.func.isRequired,
};
